import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79ebffe7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "sidebar-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sidebar-logo-container", { 'collapse': _ctx.collapse }])
  }, [
    _createVNode(_component_router_link, {
      class: "sidebar-logo-link",
      to: "/"
    }, {
      default: _withCtx(() => [
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logo,
              class: "sidebar-logo"
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true),
        (!_ctx.collapse || !_ctx.logo)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}